import React, { useContext } from "react";
import { Button, Icon, Popover, Badge } from "antd";
import { ModuleHeader } from '~/components/ModuleHeader';
import Search from '~/_shared/components/Search';
import MonthPicker from '~/_shared/components/MonthPicker';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import moment from 'moment';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';
import { MarketingFiltersContext, toBoardDate } from '../filters';

const Header = ({
  title,
  searchQuery,
  setSearchQuery,
  searchResultsCount,
  onAddItem,
  selectedDate,
  onDateChange,
  showDateNavigation = false
}) => {
  // Persisted filters of the page (month per board), when the page provides them.
  var filtersContext = useContext(MarketingFiltersContext);
  var persisted = filtersContext ? filtersContext.persisted : null;
  var defaultDate = persisted ? toBoardDate(persisted.defaults.month) : moment().format("MM-YYYY");

  var isDateChanged = !!(showDateNavigation && selectedDate && selectedDate !== defaultDate);
  // Badge: only what differs from the defaults.
  var activeFilterCount = (isDateChanged ? 1 : 0) + (searchQuery ? 1 : 0);

  var resetDate = function() {
    onDateChange(defaultDate);
  };

  var handleClearAll = function() {
    if (persisted) {
      persisted.resetFilters();
    } else {
      resetDate();
    }
    if (searchQuery) setSearchQuery('');
  };

  var displayDate = selectedDate ? moment(selectedDate, "MM-YYYY").format("MMM/YYYY") : moment().format("MMM/YYYY");

  return (
    <>
      <ModuleHeader
        breadcrumbs={['Marketing', title === 'Convites' ? 'Convites' : 'Missões']}
        title={title === 'Convites' ? 'Convites' : 'Missões'}
        search={
          <Search
            value={searchQuery}
            onChange={function(e) { setSearchQuery(e.target.value); }}
            placeholder="Buscar itens"
            resultsCount={searchResultsCount}
          />
        }
        center={
          showDateNavigation ? (
            <Popover
              trigger="click"
              placement="bottomRight"
              content={
                <div style={{ width: 280 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                    {activeFilterCount > 0 && (
                      <a
                        style={{ fontSize: 12, color: '#f5222d' }}
                        onClick={handleClearAll}
                      >
                        Limpar
                      </a>
                    )}
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <span style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 4, display: 'block' }}>Mês / Ano</span>
                    <MonthPicker
                      value={moment(selectedDate, "MM-YYYY").format("YYYY-MM")}
                      onChange={function(newDate) {
                        var formattedDate = moment(newDate, "YYYY-MM").format("MM-YYYY");
                        onDateChange(formattedDate);
                      }}
                      showTodayButton={false}
                      style={{ display: 'block', width: '100%' }}
                    />
                  </div>
                </div>
              }
            >
              <Badge
                count={activeFilterCount}
                offset={[-4, 0]}
                style={{ backgroundColor: '#722ed1' }}
              >
                <Button icon="bars" style={{ borderRadius: 8 }}>Filtros</Button>
              </Badge>
            </Popover>
          ) : undefined
        }
        actions={
          <Button icon="plus" shape="circle" onClick={onAddItem} />
        }
        advanced={
          showDateNavigation ? (
            (function() {
              var pills = [];
              pills.push({
                key: 'month',
                label: displayDate,
                color: '#1890ff',
                icon: 'calendar',
                onRemove: isDateChanged ? resetDate : undefined,
              });
              if (searchQuery) {
                pills.push({
                  key: 'search',
                  label: 'Busca: ' + searchQuery,
                  color: '#722ed1',
                  icon: 'search',
                  onRemove: function() { setSearchQuery(''); },
                });
              }
              return React.createElement(FilterPillsBar, {
                pills: pills,
                onClearAll: activeFilterCount > 0 ? handleClearAll : undefined,
              });
            })()
          ) : undefined
        }
      />
      {persisted && (
        <RestoredFiltersNotice
          visible={persisted.wasRestored}
          summary={'Mês: ' + displayDate}
          onReset={handleClearAll}
          onDismiss={persisted.dismissRestored}
        />
      )}
    </>
  );
};

export default Header;